// react
import React, { useState, useEffect, useMemo } from "react";

// third-party
import { Helmet } from "react-helmet-async";
// import { FloatingWhatsApp } from 'react-floating-whatsapp-button';
// import FloatingWhatsApp from "react-floating-whatsapp";
import "react-floating-whatsapp-button/dist/index.css";
// import css from '../../scss/blocks/style-module.scss'

// application
import shopApi from "../../api/shop";
import { useDeferredData, useProductColumns, useProductTabs } from "../../services/hooks";

// blocks
// import BlockBanner from "../blocks/BlockBanner";
// import BlockBannerDown from "../blocks/BlockBannerDown";
import BlockBrands from "../blocks/BlockBrands";
import BlockFeatures from "../blocks/BlockFeatures";
import BlockSlideShowVideo from "../blocks/BlockSlideShowVideo";
import BlockProducts from "../blocks/BlockProducts";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import BlockProductsPromo from "../blocks/BlockProductsPromo";
import BlockSlideShow from "../blocks/BlockSlideShow";
import BlockKategori from "../blocks/BlockKategory";
// import BlockMenu from "../blocks/BlockMenu";


// data stubs
import theme from "../../data/theme";
// import BlockCategory from "../blocks/BlockCategory";
import BlockBannerSlideShow1 from "../blocks/BlockBannerSlideShow1";
import BlockBannerSlideShow2 from "../blocks/BlockBannerSlideShow2";

function HomePageOne(props) {
	// Set ke true untuk menampilkan kembali fitur Flash Sale tanpa menghapus kode
	const SHOW_FLASH_SALE = false;

	const calculateNextFlashSale = () => {
		const now = new Date(); // Waktu saat ini
		const currentHours = now.getHours(); // Jam saat ini
		const nextFlashSaleHour = Math.ceil((currentHours + 1) / 6) * 6; // Membulatkan ke kelipatan 6 jam berikutnya
		const nextFlashSaleDate = new Date(now);
	
		if (nextFlashSaleHour >= 24) {
			// Jika melewati tengah malam, reset ke hari berikutnya
			nextFlashSaleDate.setDate(now.getDate() + 1);
			nextFlashSaleDate.setHours(nextFlashSaleHour - 24);
		} else {
			nextFlashSaleDate.setHours(nextFlashSaleHour);
		}
	
		nextFlashSaleDate.setMinutes(0); // Reset menit ke 0
		nextFlashSaleDate.setSeconds(0); // Reset detik ke 0
	
		return nextFlashSaleDate;
	};

	const useFlashSaleTimer = () => {
		const [timeLeft, setTimeLeft] = useState(null);
	
		useEffect(() => {
			const updateTimer = () => {
				const nextFlashSale = calculateNextFlashSale();
				const now = new Date();
				const timeDifference = nextFlashSale - now;
	
				if (timeDifference > 0) {
					const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
					const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
					const seconds = Math.floor((timeDifference / 1000) % 60);
	
					setTimeLeft(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`);
				} else {
					setTimeLeft("00:00:00"); // Flash sale telah berakhir
				}
			};
	
			updateTimer(); // Hitung waktu tersisa saat pertama kali dimuat
			const intervalId = setInterval(updateTimer, 1000); // Perbarui setiap detik
	
			return () => clearInterval(intervalId); // Bersihkan interval saat komponen di-unmount
		}, []);
	
		return timeLeft;
	};

	const timeLefts = useFlashSaleTimer(); // Menggunakan hook timer

	

	// console.log(process.env.PUBLIC_URL);
	/**
	 * Category tabs for "Semua Produk" section.
	 */
	const productTabs = useMemo(
		() => [
			{ id: 1, name: "Semua", categoryId: undefined },
			{ id: 2, name: "Bahan Bangunan", categoryId: 2 },
			{ id: 3, name: "Cat", categoryId: 3 },
			{ id: 4, name: "Kamar Mandi", categoryId: 7 },
			{ id: 5, name: "Lantai & Dinding", categoryId: 8 },
			{ id: 6, name: "Dapur", categoryId: 4 },
			{ id: 7, name: "Alat Pertukangan", categoryId: 1 },
		],
		[]
	);

	/**
	 * Featured products for "Semua Produk" section with category tabs.
	 */
	const featuredProducts = useProductTabs(
		productTabs,
		(tab) => shopApi.getPopularProducts({ limit: 16, categoryId: tab?.categoryId })
	);

	/**
	 * Bestsellers (diverse, high-appeal products distinct from "Semua Produk").
	 */
	const bestsellers = useDeferredData(() => shopApi.getBestsellers({ limit: 7 }), []);

	/**
	 * Latest products.
	 */
	const latestProducts = useProductTabs(
		useMemo(
			() => [
				{ id: 1, name: "All", categorySlug: undefined },
				{ id: 2, name: "Power Tools", categorySlug: "power-tools" },
				{ id: 3, name: "Hand Tools", categorySlug: "hand-tools" },
				{ id: 4, name: "Plumbing", categorySlug: "plumbing" },
			],
			[]
		),
		(tab) => shopApi.getLatestProducts({ limit: 8, category: tab.categorySlug })
	);

	/**
	 * Product columns.
	 */
	const columns = useProductColumns(
		useMemo(
			() => [
				{
					title: "Top Rated Products",
					source: () => shopApi.getTopRatedProducts({ limit: 3 }),
				},
				{
					title: "Special Offers",
					source: () => shopApi.getDiscountedProducts({ limit: 3 }),
				},
				{
					title: "Bestsellers",
					source: () => shopApi.getBestsellerdown({ limit: 3 }),
				},
			],
			[]
		)
	);

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Beranda | ${theme.name}`}</title>
			</Helmet>

			{/* 1. Hero Carousel Banner & Promo Posters (Video YouTube di-comment sementara) */}
			{useMemo(
				() => (
					<BlockSlideShowVideo withDepartments />
				),
				[]
			)}

			{/* 2. Kategori Produk (Tepat di bawah carousel) */}
			{useMemo(
				() => (
					<BlockKategori />
				),
				[]
			)}

			{/* 3. Bar Fitur & Keunggulan Belanja Hokky (Gratis Ongkir, 24/7 Support, 100% Aman) */}
			{useMemo(
				() => (
					<BlockFeatures layout="classic" />
				),
				[]
			)}

			{/* Flash Sale (Disembunyikan sementara, set SHOW_FLASH_SALE = true untuk mengaktifkan kembali) */}
			{SHOW_FLASH_SALE && (
				<BlockProductsPromo
					title="Flash Sale"
					layout="grid-5"
					rows={2}
					waktu={timeLefts}
					products={featuredProducts.data}
					loading={featuredProducts.isLoading}
					onGroupClick={featuredProducts.handleTabChange}
				/>
			)}

			{/* 4. Produk Unggulan / Best Seller */}
			{useMemo(
				() => (
					<BlockProducts
						title="Best Seller"
						layout="large-first"
						loading={bestsellers.isLoading}
						featuredProduct={bestsellers.data[0]}
						products={bestsellers.data.slice(1, 7)}
					/>
				),
				[bestsellers.isLoading, bestsellers.data]
			)}

			{/* 5. Banner Promo Slider 1 (Propan & Semen Merah Putih) */}
			{useMemo(
				() => (
					<BlockBannerSlideShow1 />
				),
				[]
			)}

			{/* 6. Katalog Semua Produk (Tepat di bawah Banner Promo) */}
			{useMemo(
				() => (
					<BlockProductsCarousel
						title="Semua Produk"
						layout="grid-4"
						rows={2}
						products={featuredProducts.data}
						loading={featuredProducts.isLoading}
						groups={featuredProducts.tabs}
						onGroupClick={featuredProducts.handleTabChange}
					/>
				),
				[featuredProducts]
			)}

			{/* 7. Banner Promo Slider 2 */}
			{useMemo(
				() => (
					<BlockBannerSlideShow2 />
				),
				[]
			)}

			{/* 8. Brand Rekanan Resmi (Makita, Bosch, Onda, Philips, dll) */}
			{useMemo(
				() => (
					<BlockBrands />
				),
				[]
			)}

			{/* <nav className="navbar navbar-dark navbar-expand d-lg-block d-none">
				<FloatingWhatsApp
					phoneNumber="+6281217853300"
					accountName="Hokky Bangunan"
					statusMessage="Online 1 menit yang lalu"
					chatMessage="Selamat datang di Hokky Bangunan. Ada yang bisa saya Bantu ?"
					avatar="https://hbs-sby.s3.ap-southeast-1.amazonaws.com/logo_hokky.png"
					allowClickAway
				/>
			</nav> */}
		</React.Fragment>
	);
}

export default HomePageOne;
